import { createStore } from 'vuex'

import http from '@/extensions/http/index.js'

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {
    submitForm(context, { city_id, form_id, fields }) {
      return new Promise((resolve, reject) => {
        http
          .post('/inscription', { city_id, form_id, fields })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },
  },
  modules: {},
})
